import ConversationContentBox from '@/components/AgentChat/AgentChatConversationContent/ConversationContentBox';

// @vue/component
export default {
  name: 'AgentChatConversationContent',
  components: {
    ConversationContentBox,
  },
};
